import React, { useState } from 'react';

const RechargeHistoryComponent = () => {
  const [selectedOption, setSelectedOption] = useState('');
  const [filteredHistory, setFilteredHistory] = useState([]);
  
  const rechargeHistoryData = [
    {
      srNo: 1,
      transactionId: 'TXN207480129',
      userName: 'Deepankar Kushwaha',
      userMobile: '9795225773',
      rechargeMobile: '9795225773',
      rechargePersonName: 'Deepankar Kushwaha',
      operatorName: 'Kotak Mahindra Bank Credit Card',
      amount: 60000,
      message: 'Success',
      rechargeDate: '11/29/2024 2:06:56 PM',
      rechargeType: 'Credit Card',
      status: 'SUCCESS',
    },
    {
      srNo: 2,
      transactionId: 'TXN91450752',
      userName: 'Deepankar Kushwaha',
      userMobile: '9795225773',
      rechargeMobile: '9795225773',
      rechargePersonName: 'Deepankar Kushwaha',
      operatorName: 'Kotak Mahindra Bank Credit Card',
      amount: 60000,
      message: 'Success',
      rechargeDate: '11/29/2024 2:06:02 PM',
      rechargeType: 'Credit Card',
      status: 'SUCCESS',
    },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Selected Option:', selectedOption);
    setFilteredHistory(rechargeHistoryData);
  };

  const containerStyle = {
    padding: '20px',
    backgroundColor: '#f4f4f9',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    maxWidth: '1200px',
    margin: '20px auto',
    fontSize: '14px',
  };

  const formGroupStyle = {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '20px',
    width: '220px',
  };

  const labelStyle = {
    fontWeight: 'bold',
    marginBottom: '8px',
    fontSize: '14px',
    color: '#333',
  };

  const selectStyle = {
    padding: '10px',
    fontSize: '14px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    marginBottom: '15px',
    backgroundColor: '#fff',
  };

  const buttonStyle = {
    padding: '6px 12px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '12px',
    width: 'auto',
    marginTop: '10px', // Ensures button has space from other form elements
  };

  const buttonHoverStyle = {
    backgroundColor: '#0056b3',
  };

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '20px',
    fontSize: '14px',
    borderRadius: '8px',
    overflow: 'hidden',
  };

  const thTdStyle = {
    border: '1px solid #ddd',
    padding: '12px',
    textAlign: 'left',
    color: '#333',
  };

  const thStyle = {
    backgroundColor: '#f1f1f1',
    fontWeight: 'bold',
    color: '#555',
  };

  const tableRowStyle = {
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: '#f9f9f9',
    },
  };

  return (
    <div style={containerStyle}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px', fontSize: '18px', color: '#333' }}>
        Recharge History
      </h2>

      <form onSubmit={handleSubmit}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
          <div style={formGroupStyle}>
            <label style={labelStyle}>Select Option</label>
            <select
              style={selectStyle}
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.target.value)}
            >
              <option value="">--Select--</option>
              <option value="option1">Option 1</option>
              <option value="option2">Option 2</option>
            </select>
          </div>
          <div style={formGroupStyle}>
            <label style={labelStyle}>Select Option</label>
            <select
              style={selectStyle}
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.target.value)}
            >
              <option value="">--Select--</option>
              <option value="option1">Option 1</option>
              <option value="option2">Option 2</option>
            </select>
          </div>
          
          {/* Align the button to the left */}
          <div style={{ alignSelf: 'flex-start', marginLeft: '10px' }}>
            <button
              type="submit"
              style={buttonStyle}
              onMouseEnter={(e) => (e.target.style.backgroundColor = buttonHoverStyle.backgroundColor)}
              onMouseLeave={(e) => (e.target.style.backgroundColor = '#007bff')}
            >
              Submit
            </button>
          </div>
        </div>
      </form>

      {/* Recharge Balance Section */}
      <div style={{ marginTop: '20px', fontSize: '16px', color: '#555' }}>
        <strong>Recharge Balance:</strong> 120000
      </div>

      {/* Table displaying recharge history */}
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={{ ...thTdStyle, ...thStyle }}>Sr. No.</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Transaction Id</th>
            <th style={{ ...thTdStyle, ...thStyle }}>User Name</th>
            <th style={{ ...thTdStyle, ...thStyle }}>User Mobile</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Recharge Mobile</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Recharge Person Name</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Operator Name</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Amount</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Message</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Recharge Date</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Recharge Type</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Status</th>
          </tr>
        </thead>
        <tbody>
          {filteredHistory.length > 0 ? (
            filteredHistory.map((recharge) => (
              <tr key={recharge.srNo} style={tableRowStyle}>
                <td style={thTdStyle}>{recharge.srNo}</td>
                <td style={thTdStyle}>{recharge.transactionId}</td>
                <td style={thTdStyle}>{recharge.userName}</td>
                <td style={thTdStyle}>{recharge.userMobile}</td>
                <td style={thTdStyle}>{recharge.rechargeMobile}</td>
                <td style={thTdStyle}>{recharge.rechargePersonName}</td>
                <td style={thTdStyle}>{recharge.operatorName}</td>
                <td style={thTdStyle}>{recharge.amount}</td>
                <td style={thTdStyle}>{recharge.message}</td>
                <td style={thTdStyle}>{recharge.rechargeDate}</td>
                <td style={thTdStyle}>{recharge.rechargeType}</td>
                <td style={thTdStyle}>{recharge.status}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="12" style={thTdStyle}>No recharge history available</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default RechargeHistoryComponent;
